const ROUTE = {
  AUTH_SIGN_IN: "/login",
  HOME: "/",
};

export default ROUTE;
